import { Link } from "react-router-dom";
import Footer from "../../Layouts/Footer";
import "./about.css";

const About = () => {
  return (
    <>
      {/* <Header /> */}
      <div id="ajax-content-wrap">
        <div className="breadcrumb">
          <span><span><Link to="/">Home</Link> / <span className="breadcrumb_last" aria-current="page">
            ABOUT US </span></span></span> </div>
        <div id="page-header-wrap" data-animate-in-effect="none" data-midnight="light" className="" style={{ height: '200px' }}>
          <div id="page-header-bg" className="not-loaded " data-padding-amt="low"
            data-animate-in-effect="none" data-midnight="light" data-text-effect="none"
            data-bg-pos="center" data-alignment="center" data-alignment-v="middle" data-parallax="0" data-height="200"
            style={{ backgroundColor: "#E8F5E5", height: "200px" }}>
            <div className="container">
              <div className="row">
                <div className="col span_6 ">
                  <div className="inner-wrap">
                    <h1 className="colored_in_black">About US </h1>
                    <span className="subheader"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className="container-wrap">
          <div className="container main-content">
            <div className="row">
              <p>
                <span data-mce-type="bookmark" className="mce_SELRES_start about_style_1">﻿</span>
            </p>
            <div id="about_us" data-column-margin="default" data-midnight="dark" className="wpb_row vc_row-fluid vc_row  vc_row-o-equal-height vc_row-flex   right_padding_85px left_padding_85px right_padding_tablet_65px right_padding_phone_20px left_padding_tablet_65px left_padding_phone_20px about_style_2">
              <div className="row-bg-wrap" data-bg-animation="none" data-bg-overlay="false">
                <div className="inner-wrap">
                  <div className="row-bg" >
                  </div>
                </div>
              </div>
              <div className="row_col_wrap_12 col span_12 dark left" style={{paddingLeft:'85px',paddingRight:'85px'}}>
                <div className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
                  <div className="vc_column-inner">
                    <div className="wpb_wrapper">

                      <div className="wpb_text_column wpb_content_element ">
                        <div className="wpb_wrapper">
                          <h4 className="about_style_3"><span className="about_style_4">Our Commitment</span></h4>
                      </div>
                    </div>




                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p className="about_align_center">LUXURY, SAFE, NON-TOXIC SKINCARE</p>
                        <p className="about_align_center">WOMEN OF ANY RACE – ANY TYPE OF SKIN – ANY RANGE OF AGE</p>
                        <p className="about_align_center">LapOtencielle is a revolutionary organic skincare brand committed to giving pure, 100% high-quality, natural, botanical, organic ingredients without compromising. Thoughtfully formulated by a woman that is devoted to not only providing the best product. Yet, a product that will work for any woman, no matter their age or race, all around the globe. Each product has the right amount of combinations of each ingredient, guaranteeing that you’re getting the right amount of nutrients your skin deserves.</p>
                        <p className="about_align_center">NO PERFUME- NO DYE -NO PARABEN -NATURAL SCENTED – CHEMICAL-FREE.</p>
                      </div>
                    </div>




                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <h4 className="about_align_center"><span className="about_style_5">Sandra’s Story</span></h4>
                      </div>
                    </div>




                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p className="about_align_left">For years Sandra Boffoh,&nbsp;the founder of LapOtencielle, tried every product on the market to get rid of her severe acne and skin problems throughout her adolescent and adulthood years. From the cheapest to the most expensive, to synthetic to organic, and even prescriptions. Unfortunately, all her efforts to find something that worked were unsuccessful. In 2013 her third child was born with a severe eczema problem from head to toe, again she realized that none of the prescriptions that the doctor prescribed were treating the problem, however, relieving it.</p>
                        <p className="about_align_left">As a Christian woman of faith, she began to pray about her daughter’s skin problem, seeking God’s advice. By a dream, God revealed the actual dilemma of her daughter’s and her’s skin problems. The chemicals and harsh ingredients in all the products she was using were causing her daughter’s eczema and her skin problems. From that revelation, the spirit of the Lord guided Sandra to start reading and researching about: plants, herbs, natural oils, and different kinds of butter. After one year of research in 2017, Sandra Boffoh made two luxury organic and natural body lines today called ORANGE &amp; VANILLA and LILY &amp; LAVENDER, named after her daughter that had extreme eczema, who she nicknamed ‘Lily’. She also made a hair line.</p>
                        <p className="about_align_left">Her products from the two body lines dramatically put the end of her daughter’s eczema. Not only that made her and her whole family’s skin healthier, younger, refined, and glowy as well. People that she shared the line with had a dramatic change in their skin as well. At that point, Sandra knew her products weren’t only for her and her family but women struggling with their skin. She didn’t stop there; in 2019, Sandra Boffoh created AGE GRACEFULLY, natural organic facial products that will undeniably work on young women to mature women. Because she believes any woman, young or mature, should feel great in their skin, no matter their age or what life is throwing at them. They should always have a youthful glow, which is the will of God for every woman. Sandra is still working hard; the best is still on the way!!!! To Jesus Christ, we give all the Glory!</p>
                      </div>
                    </div>



                    <div className="divider-wrap" data-alignment="default"><div style={{height: '25px'}} className="divider"></div></div><div id="fws_644b0f6e9f01f" data-midnight="" data-column-margin="default" className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex vc_row-o-content-middle "><div className="row-bg-wrap"> <div className="row-bg"></div> </div><div className="row_col_wrap_12_inner col span_12  left">
                      <div className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
                        <div className="vc_column-inner">
                          <div className="wpb_wrapper">
                            <div className="img-with-aniamtion-wrap " data-max-width="100%" data-max-width-mobile="default" data-shadow="none" data-animation="fade-in">
                              <div className="inner">
                                <div className="hover-wrap" style={{opacity: 1}}>
                                  <div className="hover-wrap-inner img-loaded">
                                  <img decoding="async" className="img-with-animation skip-lazy nectar-lazy loaded animated-in" data-delay="0" height="1018" width="1194" data-animation="fade-in" src="./assets/wp-content/uploads/2023/12/WhatsApp-Image-2023-12-26-at-7.04.40-PM.jpeg" alt="" sizes="(min-width: 1450px) 75vw, (min-width: 1000px) 85vw, 100vw"  srcSet="./assets/wp-content/uploads/2023/12/WhatsApp-Image-2023-12-26-at-7.04.40-PM.jpeg 1194w, ./assets/wp-content/uploads/2023/12/WhatsApp-Image-2023-12-26-at-7.04.40-PM-300x256.jpeg 300w, ./assets/wp-content/uploads/2023/12/WhatsApp-Image-2023-12-26-at-7.04.40-PM-1024x873.jpeg 1024w, ./assets/wp-content/uploads/2023/12/WhatsApp-Image-2023-12-26-at-7.04.40-PM-768x655.jpeg 768w, ./assets/wp-content/uploads/2023/12/WhatsApp-Image-2023-12-26-at-7.04.40-PM-600x512.jpeg 600w"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
                        <div className="vc_column-inner">
                          <div className="wpb_wrapper">

                            <div className="wpb_text_column wpb_content_element ">
                              <div className="wpb_wrapper">
                                <p>” I love doing this. It makes me extremely happy to bring something new to the table that will work and make people’s skin beautiful. The most rewarding part of doing this is knowing that I’m helping women have healthier and improved skincare. And that is my goal.”-Sandra Boffoh</p>
                                <p>” Couldn’t stand products that were only based on one element or had too many ingredients that neither my skin and I could comprehend. For me, an excellent product should have the right amount of ingredients that my skin and brain can grasp and appreciate. Just as they say, too much or too little can be harmful. The same goes with our skin; the right amount is always perfect!”-Sandra Boffoh</p>
                                <p><br className="about_border_box"/>” I wanted something that worked on all skin types and treated all different kinds of skin issues. So, I refuse to focus on one ingredient in my formula but concentrate on using the right ingredients and combinations in each product.”-Sandra Boffoh</p>
                              </div>
                            </div>




                          </div>
                        </div>
                      </div>
                    </div></div><div className="divider-wrap" data-alignment="default"><div style={{height: '25px'}} className="divider"></div></div>
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <h4 style={{textAlign: 'center'}}><span style={{textDecoration: 'underline', color: '#000000'}}>Our FORMULA</span></h4>
                      </div>
                    </div>




                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p style={{textAlign: 'center'}}>Visible process, Visible results</p>
                      </div>
                    </div>



                    <div id="about_formula" data-midnight="" data-column-margin="default" className="wpb_row vc_row-fluid vc_row inner_row  " style={{marginBottom: 0}} ><div className="row-bg-wrap"> <div className="row-bg"></div> </div><div className="row_col_wrap_12_inner col span_12  left">
                      <div className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
                        <div className="vc_column-inner">
                          <div className="wpb_wrapper">

                            <div className="wpb_text_column wpb_content_element ">
                              <div className="wpb_wrapper">
                                <h5 style={{textAlign: 'center'}}><strong style={{fontSize: '1.75rem', color: '#212529'}}>WE BELIEVE THAT MORE MATTERS.</strong></h5>
                              </div>
                            </div>




                            <div className="wpb_text_column wpb_content_element ">
                              <div className="wpb_wrapper">
                                <h5><span style={{color: '#212529'}}>We pack our products with the highest levels of concentration of ingredients to deliver maximum results—without using a single drop of artificial chemicals. Our products are for those who expect the best and want outstanding results from their skincare.</span></h5>
                                <h5><span style={{color: '#212529'}}>Our natural and organic products will give you high-performing results without using toxic chemicals. So you can achieve the effect you want without compromising with harsh chemicals. The infused oils and the botanical water used in our products are freshly made by us, giving you the best without compromising.</span></h5>
                                <h5><span style={{color: '#212529'}}>We refuse to use the same formula in our products. Each formula is uniquely made for each product to meet your skin requirements. We want something that works on all types of skin and treats all kinds of skin issues.</span></h5>
                              </div>
                            </div>




                          </div>
                        </div>
                      </div>

                      <div className="vc_col-sm-4 wpb_column column_container vc_column_container col child_column no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
                        <div className="vc_column-inner">
                          <div className="wpb_wrapper">
                            <div className="img-with-aniamtion-wrap " data-max-width="100%" data-max-width-mobile="default" data-shadow="none" data-animation="fade-in">
                              <div className="inner">
                                <div className="hover-wrap" style={{opacity: 1}}>
                                  <div className="hover-wrap-inner img-loaded">
                                    <img className="img-with-animation skip-lazy nectar-lazy animated-in loaded" data-delay="0" data-animation="fade-in" src="./assets/wp-content/uploads/2022/01/medmid.jpg" alt="" sizes="(min-width: 1450px) 75vw, (min-width: 1000px) 85vw, 100vw"  srcSet="./assets/wp-content/uploads/2022/01/medmid.jpg 669w, ./assets/wp-content/uploads/2022/01/medmid-300x886.jpg 300w, ./assets/wp-content/uploads/2022/01/medmid-600x1771.jpg 600w, ./assets/wp-content/uploads/2022/01/medmid-102x300.jpg 102w, ./assets/wp-content/uploads/2022/01/medmid-347x1024.jpg 347w, ./assets/wp-content/uploads/2022/01/medmid-520x1536.jpg 520w" width="669" height="1975"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div></div><div className="img-with-aniamtion-wrap " data-max-width="100%" data-max-width-mobile="default" data-shadow="none" data-animation="fade-in">
                      <div className="inner">
                        <div className="hover-wrap" style={{opacity: 1}}>
                          <div className="hover-wrap-inner img-loaded">
                            <img className="img-with-animation skip-lazy nectar-lazy animated-in loaded" data-delay="0" data-animation="fade-in" src="./assets/wp-content/uploads/2022/01/pure.jpg" alt="" sizes="(min-width: 1450px) 75vw, (min-width: 1000px) 85vw, 100vw" srcSet="./assets/wp-content/uploads/2022/01/pure.jpg 1575w, ./assets/wp-content/uploads/2022/01/pure-300x99.jpg 300w, ./assets/wp-content/uploads/2022/01/pure-600x198.jpg 600w, ./assets/wp-content/uploads/2022/01/pure-1024x339.jpg 1024w, ./assets/wp-content/uploads/2022/01/pure-768x254.jpg 768w, ./assets/wp-content/uploads/2022/01/pure-1536x508.jpg 1536w" width="1575" height="521"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <h4 style={{textAlign: 'center'}}><span style={{textDecoration: 'underline', color: '#000000'}}>Our Ingredients</span></h4>
                      </div>
                    </div>




                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p style={{textAlign: 'center', padding: '0px'}}><span style={{color: '#000000', fontSize: '18px'}}><strong>We don’t add fragrance to our products so you can experience the natural scents of the ingredients.</strong></span></p>
                        <p style={{textAlign: 'center'}}><span style={{color: '#000000'}}>Our high-quality ingredients come from all around the globe; each one thoughtfully selected by Sandra Boffoh to uniquely benefit your skin. We prioritize both certified-organic and wild-harvested ingredients, taking sourcing seriously, tracing each ingredient to its origins. The quality of each ingredient matters to us.</span></p>
                      </div>
                    </div>




                  </div>
                </div>
                </div>
              </div>
            </div><span data-mce-type="bookmark" style={{display: 'inline-block', width: '0px', overflow: 'hidden', lineHeight: 0}} className="mce_SELRES_end">﻿</span><p></p>
        </div>
      </div>

      <Footer />
      {/* Footer  */}
    </div>
    </div>
    </>
 );
}

export default About;